import { Component, computed, effect, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MessageBalanceService } from '@shared/services/message-balance.service';

/*
 * Franja fija arriba del contenido cuando la administración se queda sin mensajes (roja) o le quedan pocos
 * (amarilla, AF319: el umbral es el 15% de los mensajes de su categoría, ver MessageBalanceService).
 * No es un emergente: se puede ocultar con la X y vuelve a aparecer al recargar,
 * o si vuelve a quedarse sin mensajes después de haber comprado.
 */
@Component({
    selector: 'app-no-messages-banner',
    standalone: true,
    imports: [RouterLink],
    templateUrl: './no-messages-banner.component.html',
    styleUrl: './no-messages-banner.component.scss',
})
export class NoMessagesBannerComponent {
    private messageBalance = inject(MessageBalanceService);

    //estado que se ocultó con la X: si pasa de "pocos" a "sin mensajes" vuelve a aparecer
    private dismissed = signal<string | null>(null);

    status = this.messageBalance.status;
    available = this.messageBalance.availableMessages;
    //si se le acaban antes de tiempo, se sugiere la categoría siguiente (ver MessageBalanceService.upgradeSuggestion)
    upgrade = this.messageBalance.upgradeSuggestion;
    visible = computed(() => (this.status() === 'empty' || this.status() === 'low') && this.dismissed() !== this.status());

    constructor() {
        //si recupera saldo, la proxima vez que le queden pocos o ninguno el aviso vuelve a aparecer
        effect(() => {
            const status = this.messageBalance.status();
            if (status !== 'empty' && status !== 'low') {
                this.dismissed.set(null);
            }
        }, { allowSignalWrites: true });
    }

    dismiss() {
        this.dismissed.set(this.status());
    }
}
